import type { MetadataFilter } from "@/types/MetadataFilter"

export const MAX_METADATA_FILTER_VALUES = 50
export const MAX_METADATA_FILTERS = 50

export function formatMetadataFilter(filter: MetadataFilter): string {
  const operator =
    filter.matchType === "ANY_OF"
      ? "is one of"
      : filter.matchType === "CONTAINS"
        ? "contains"
        : "is"
  const value =
    filter.matchType === "ANY_OF"
      ? (filter.values ?? [])
          .map((item) => (item === "" ? "(empty)" : item))
          .join(", ")
      : filter.value
  return `${filter.key} ${operator} ${value}`
}

export function removeMetadataFilterValue(
  filters: MetadataFilter[],
  index: number,
  valueIndex: number,
): MetadataFilter[] {
  return filters.flatMap((filter, currentIndex) => {
    if (currentIndex !== index || filter.matchType !== "ANY_OF") {
      return [filter]
    }
    const values = (filter.values ?? []).filter(
      (_, currentValueIndex) => currentValueIndex !== valueIndex,
    )
    return values.length ? [{ ...filter, values }] : []
  })
}

interface MetadataFilterValidationInput {
  matchType?: string
  match_type?: string
  values?: string[]
}

export function getMetadataFilterValidationError(
  filters: MetadataFilterValidationInput[] = [],
): string | undefined {
  if (filters.length > MAX_METADATA_FILTERS) {
    return "Use at most 50 metadata filters. Remove extra filters or reset filters to continue."
  }
  for (const filter of filters) {
    if ((filter.matchType ?? filter.match_type) === "ANY_OF") {
      if (
        !Array.isArray(filter.values) ||
        filter.values.length === 0 ||
        filter.values.length > MAX_METADATA_FILTER_VALUES ||
        filter.values.some((value) => typeof value !== "string")
      ) {
        return `Each is one of filter needs 1–${MAX_METADATA_FILTER_VALUES} values. Remove the filter or extra values to continue.`
      }
    } else if (filter.values?.length) {
      return "Only is one of filters can contain multiple values. Remove the filter to continue."
    }
  }
  return undefined
}
